export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px'
};

export const TYPOGRAPHY = {
  title: {
    fontSize: 'clamp(28px, 4vw, 32px)',
    fontWeight: '700',
    lineHeight: '1.2'
  },
  subtitle: {
    fontSize: 'clamp(20px, 3vw, 24px)',
    fontWeight: '500',
    lineHeight: '1.3'
  },
  button: {
    fontSize: 'clamp(24px, 3.5vw, 28px)',
    fontWeight: '600',
    lineHeight: '1.2'
  },
  body: {
    fontSize: 'clamp(18px, 2.5vw, 22px)',
    fontWeight: '400',
    lineHeight: '1.4'
  },
  small: {
    fontSize: 'clamp(16px, 2vw, 18px)',
    fontWeight: '400',
    lineHeight: '1.3'
  }
};

export const BORDER_RADIUS = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  full: '50%'
};

export const BREAKPOINTS = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px'
};

export const TOUCH_TARGETS = {
  minSize: '56px',
  padding: '16px'
};
